exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status_icon[data-v-476c5302]::before{display:inline-block;content:\"\";width:8px;height:8px;border-radius:50%;background-color:#ff4146;margin-right:6px}.status_icon.success[data-v-476c5302]::before{background-color:#4ccb86}\n", ""]);

// exports
